module.exports = __webpack_public_path__ + "static/qrcode.8130baff.jpg";